export const DRIVERS_LICENCE_ROUTE = 'prawo-jazdy';
export const CHECK_PKK_STATUS_ROUTE = 'sprawdz-status-pkk';
export const CHECK_DRIVERS_LICENSE_STATUS_ROUTE = 'sprawdz-status-prawa-jazdy';
export const CHECK_EXAM_AVAILABILITY_ROUTE = 'sprawdz-wolny-termin';
